import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import Layout from '../../../components/Layout'
import { useParams, NavLink } from 'react-router-dom'
import PeriodeRpjmdSelector from '../../../components/PeriodeRpjmdSelector'
import { getListOpdIkd_newSakatoplan_act } from '../../../../redux/ducks/newsakatoplan/actions'
import BackButton from '../../../components/BackButton'


const ListOpdIkd = ({ getListOpdIkd, periodeState, listOpdIkdState }) => {
    const { yearconfig } = useParams()
    const breadCrumbsData = [
        {
          title: 'Home',
          isActive: true,
          goTo: '/tahun/'+yearconfig,
        },
        {
          title: `Indikator Kinerja Daerah`,
          isActive: false,
          goTo: '',
        },
    ];
    const [selectedPeriode, setSelectedPeriode] = React.useState(null)
    const onchangeperiode = (e) => {
        setSearchFilter("")
        setSelectedPeriode(e.target.value)
        getListOpdIkd(e.target.value)
    }
    const [searchFilter, setSearchFilter] = React.useState("")
    const filteredBySearch = () => {
        if (searchFilter === '') {
          return listOpdIkdState.data;
        } else return listOpdIkdState.data.filter((items) => items.nm_instansi.toLowerCase().includes(searchFilter.toLowerCase()));
    }
    React.useEffect(() => {
        if(periodeState.data.length > 0){
            let e = {
                target: {
                    value: 2
                }
            }
            onchangeperiode(e)
        }
    },[])
    return (
        <Layout
            loading={false}
            breadCrumbsData={breadCrumbsData}
        >
            <div
                className="bg-white rounded-lg drop-shadow-2xl py-5 px-2 w-full"
            >
                <div className="flex-grow bg-white rounded-xl py-2 relative">
                    <h1 className="text-lg font-bold text-primeColor1 text-center">Indikator Kinerja Daerah</h1>
                    <h1 className="mb-1 text-sm text-gray-400 text-center">
                    pilih OPD di bawah untuk melihat indikator kinerja daerah
                    </h1>
                    <hr className="mb-3" />
                </div>
                <div className="flow-grow bg-white rounded-xl py-2 relative gap-3 flex justify-between items-end px-4">
                    <div className="lg:w-1/3 md:w-1/2 w-full flex gap-2 flex-col">
                        <label for="table-search" className="italic font-bold text-xs">
                            Search
                        </label>
                        <div className="relative mt-1">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                            <svg
                                className="w-5 h-5 text-gray-500"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                            <path
                                fill-rule="evenodd"
                                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                clip-rule="evenodd"
                            ></path>
                            </svg>
                        </div>
                        <input
                            type="text"
                            onChange={(e) => setSearchFilter(e.target.value)}
                            value={searchFilter}
                            className="bg-gray-50 border border-gray-300 text-gray-800 text-sm font-bold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-1.5 placeholder:text-gray-900 "
                            placeholder="Cari berdasarkan nama OPD"
                        />
                        </div>
                    </div>
                    <div className="lg:w-1/3 md:w-1/2 w-full flex gap-2 flex-col">
                        <PeriodeRpjmdSelector selectedValue={selectedPeriode} onChangeAction={onchangeperiode} />
                    </div>
                </div>
                <div className="w-full grid xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-1">
                {
                    filteredBySearch().map((val,keys) => {
                        return (
                                <div>
                                <NavLink to={`/tahun/${yearconfig}/ikd/data-ikd-opd/${val.id}/${val.nm_instansi}?periode_id=${selectedPeriode}`} 
                                    className="cursor-pointer flex flex-row gap-3 p-2 group rounded-xl group 
                                    hover:bg-white hover:text-primeColor2 bg-primeColor2 text-primeColor1 hover:border-primeColor2 border-white 
                                    border-2 h-16 overflow-hidden sm:items-center">
                                    <div className="flex items-center justify-center p-1">
                                        <span 
                                            className="rounded-full p-1.5 group-hover:bg-primeColor2 group-hover:text-white bg-white text-primeColor1">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z" />
                                            </svg>

                                        </span>
                                    </div>
                                    <p className="text-[1em] leading-none">
                                        {val.nm_instansi}
                                    </p>
                                </NavLink>
                                </div>
                            )
                    })
                }
                </div>
            </div>
            <BackButton backLink={'/tahun/'+yearconfig} />
        </Layout>
    )
}

const mapStateToProps = (state) => ({
    periodeState: state.newsakatoplanState.periodeRpjmd,
    listOpdIkdState: state.newsakatoplanState.listOpdIkd
})

const mapDispatchToProps = {
    getListOpdIkd: getListOpdIkd_newSakatoplan_act
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

export default compose(withConnect, React.memo)(ListOpdIkd)